/**
 * The reference an order is known by: online (Shopify) orders keep their Shopify
 * order number (e.g. "#20470") through every step; everything else shows the
 * ERP enquiry number.
 */
export function orderRef(e?: { enqNo?: string | null; source?: string | null; customerPoRef?: string | null } | null): string {
  if (!e) return '—';
  if (e.source === 'Shopify' && e.customerPoRef) return e.customerPoRef;
  return e.enqNo || '—';
}

/**
 * Online (Shopify) view of a pipeline list: track by the Shopify order ID only —
 * drop the ERP document-number columns (`drop`) and lead with the order ID column.
 */
export function trackByOrderId<C extends { key: string }>(online: boolean, orderCol: C, drop: string[], cols: C[]): C[] {
  return online ? [orderCol, ...cols.filter((c) => !drop.includes(c.key))] : cols;
}
